import { useMediaQuery, useTheme } from '@mui/material';
import { useMeasure } from '@react-hookz/web';
import { memo, useEffect } from 'react';

type GoogleLoginProps = {
  options?: any;
  fullWidth?: boolean;
};

const GoogleLogin = memo(({ options, fullWidth }: GoogleLoginProps) => {
  const theme = useTheme();
  const xsScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const [measures, buttonEl] = useMeasure<HTMLDivElement>();
  const width = fullWidth ? measures?.width : undefined;

  useEffect(() => {
    if (!buttonEl.current) return;
    const google = (window as any).google;
    google.accounts.id.renderButton(buttonEl.current, {
      ...(options || (xsScreen ? { type: 'icon', shape: 'pill' } : { theme: 'outline' })),
      width,
    });
  }, [options, xsScreen, buttonEl, width]);

  return <div ref={buttonEl} id="google_login_button"></div>;
});

export { GoogleLogin };
